import { render, staticRenderFns } from "./TelegramOtpTemplate.vue?vue&type=template&id=04f7b0b2&"
import script from "./TelegramOtpTemplate.vue?vue&type=script&lang=ts&"
export * from "./TelegramOtpTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports